import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { createSlice } from '@reduxjs/toolkit';
import { formatCommonKeys } from "../../utils";
import { requestApiTexts } from "./actions/requestApiTexts";
import { EMPTY_CTN } from "./constants";
import { submitCallbackRequest } from "./actions/submitCallbackRequest";
var initialState = {
  ctn: '',
  isCaptchaError: false,
  isCaptchaRequired: false,
  isLoading: false,
  isCtnError: false,
  isSuccess: false,
  refreshCaptcha: 0,
  captchaValue: '',
  captchaKey: '',
  fttbPersonalVerificationCheckboxEnable: {
    personalVerificationCheckboxEnable: false
  }
};
export var callbackRequestSLice = createSlice({
  name: 'callbackRequest',
  initialState: initialState,
  reducers: {
    setCtn: function setCtn(state, _ref) {
      var payload = _ref.payload;
      state.ctn = payload;
    },
    setIsCaptchaError: function setIsCaptchaError(state, _ref2) {
      var _ref2$payload = _ref2.payload,
        payload = _ref2$payload === void 0 ? false : _ref2$payload;
      state.isCaptchaError = payload;
    },
    setIsCtnError: function setIsCtnError(state, _ref3) {
      var _ref3$payload = _ref3.payload,
        payload = _ref3$payload === void 0 ? false : _ref3$payload;
      state.isCtnError = payload;
    },
    setLoading: function setLoading(state, _ref4) {
      var payload = _ref4.payload;
      state.isLoading = payload;
    },
    setRefreshCaptcha: function setRefreshCaptcha(state) {
      state.refreshCaptcha = new Date().getTime();
    },
    setCaptchaValue: function setCaptchaValue(state, _ref5) {
      var payload = _ref5.payload;
      state.captchaValue = payload;
    },
    setCaptchaKey: function setCaptchaKey(state, _ref6) {
      var payload = _ref6.payload;
      state.captchaKey = payload;
    }
  },
  extraReducers: function extraReducers(builder) {
    builder.addCase(submitCallbackRequest.fulfilled, function (state, _ref7) {
      var payload = _ref7.payload;
      state.isLoading = false;
      state.isSuccess = payload.isSucceeded;
      state.isCaptchaError = payload.isCaptchaError;
      state.isCaptchaRequired = payload.shouldShowCaptcha;
      if (payload.isCaptchaError) state.refreshCaptcha = new Date().getTime();
    }).addCase(submitCallbackRequest.rejected, function (state, _ref8) {
      var payload = _ref8.payload;
      state.isLoading = false;
      if (payload === EMPTY_CTN) state.isCtnError = true;
    }).addCase(submitCallbackRequest.pending, function (state) {
      state.isLoading = true;
    }).addCase(requestApiTexts.fulfilled, function (state, _ref9) {
      var payload = _ref9.payload;
      Object.entries(formatCommonKeys(payload.texts)).forEach(function (_ref10) {
        var _ref11 = _slicedToArray(_ref10, 2),
          key = _ref11[0],
          value = _ref11[1];
        // @ts-expect-error fix later
        state[key] = value;
      });
    });
  }
});
var _callbackRequestSLice = callbackRequestSLice.actions,
  setCtn = _callbackRequestSLice.setCtn,
  setLoading = _callbackRequestSLice.setLoading,
  setIsCtnError = _callbackRequestSLice.setIsCtnError,
  setRefreshCaptcha = _callbackRequestSLice.setRefreshCaptcha,
  setIsCaptchaError = _callbackRequestSLice.setIsCaptchaError,
  setCaptchaValue = _callbackRequestSLice.setCaptchaValue,
  setCaptchaKey = _callbackRequestSLice.setCaptchaKey;
export { setCtn, setLoading, setIsCtnError, setRefreshCaptcha, setIsCaptchaError, setCaptchaValue, setCaptchaKey };
export var callbackRequestReducer = callbackRequestSLice.reducer;